module.exports = __webpack_public_path__ + "static/media/sweet_9.1bfada66.png";